import entityContainerConnector from '~components/generic/entityContainerConnector';
import Page from '~components/page/Page';

export default entityContainerConnector(Page);
